import { render, staticRenderFns } from "./SelectionDisabled.vue?vue&type=template&id=163357a0"
import script from "./SelectionDisabled.vue?vue&type=script&lang=js"
export * from "./SelectionDisabled.vue?vue&type=script&lang=js"
import style0 from "./SelectionDisabled.vue?vue&type=style&index=0&id=163357a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports